// src/pages/LoeschenPage.js
import React from "react";
import "./LoeschenPage.css";

function LoeschenPage() {
  return (
    <div className="datenschutz-page">
      <div className="legal-container">
        <h1>Konto und Daten löschen</h1>

        <p>
          Wenn Sie Ihr Benutzerkonto bei <strong>Edens Ernte</strong> löschen
          möchten, können Sie dies jederzeit beantragen.
        </p>

        <h2>So funktioniert die Löschung</h2>
        <p>
          Senden Sie bitte eine E-Mail an:
        </p>

        <p>
          <strong>info@edens-ernte.app</strong>
        </p>

        <p>
          Geben Sie in Ihrer Nachricht bitte die E-Mail-Adresse an, mit der Ihr
          Konto bei Edens Ernte registriert wurde.
        </p>

        <p>
          Bitte senden Sie Ihre Anfrage idealerweise von der bei uns registrierten
          E-Mail-Adresse, damit wir Ihr Anliegen eindeutig zuordnen können.
        </p>

        <h2>Welche Daten werden gelöscht?</h2>
        <ul>
          <li>Ihr Benutzerkonto</li>
          <li>Ihre Profilinformationen</li>
          <li>von Ihnen erstellte Beiträge und Antworten</li>
          <li>
            Ihre gespeicherten personenbezogenen Daten, soweit keine gesetzlichen
            Aufbewahrungspflichten bestehen
          </li>
        </ul>

        <h2>Speicherdauer nach Anfrage</h2>
        <p>
          Nach Eingang Ihrer Anfrage wird Ihr Konto in der Regel innerhalb von
          <strong> 7 Tagen</strong> gelöscht.
        </p>

        <h2>Wichtiger Hinweis</h2>
        <p>
          Die Löschung erfolgt unwiderruflich und umfasst alle mit dem Konto
          verbundenen Daten, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.
        </p>

        <p>
          Zur Sicherheit behalten wir uns vor, die Identität des Anfragenden zu prüfen,
          bevor eine Kontolöschung durchgeführt wird.
        </p>

        <p>
          Gesetzliche Aufbewahrungspflichten oder technisch erforderliche Restdaten
          können im Einzelfall einer sofortigen vollständigen Löschung entgegenstehen.
          In diesem Fall werden die Daten nur so lange gespeichert, wie dies rechtlich
          erforderlich ist.
        </p>

        <h2>Kontakt</h2>
        <p>
          Bei Fragen zur Kontolöschung oder zum Datenschutz wenden Sie sich bitte an:
        </p>

        <p>
          <strong>
            <a href="mailto:info@edens-ernte.app">info@edens-ernte.app</a>
          </strong>
        </p>
      </div>
    </div>
  );
}

export default LoeschenPage;